import { addCollect, cancelCollect } from '@/common/api/game.js'
import noData from '@/common/components/noData/index.vue'
import loadMoreBtn from '@/common/components/load-more-btn/index.vue'
import XHeader from '@/common/components/g-header/index.vue'
export default {
  components: { noData, loadMoreBtn, XHeader },
  props: {
    showPart: { // 是否显示部分数据
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadmore: true,
      finish: Function,
      pages: { pageNo: 1, pageSize: 12 },
      list: [],
      total: null
    }
  },
  methods: {
    handleAddCollect(params = {}, index) { // 添加收藏
      addCollect(params).then(([data, err, res]) => {
        if (!err) this.implementationFetchedCollect([data, res], index, '1')
        this.showCollect(res.data, this.$t('games').collectSuccess)
      })
    },

    handleCancelCollect(params = {}, index) { // 取消收藏
      cancelCollect(params).then(([data, err, res]) => {
        if (!err) this.implementationFetchedCollect([data, res], index, '0')
        this.showCollect(res.data, this.$t('games').collectCancel)
      })
    },

    implementationFetchedCollect([data, res], index, type) { // type 1 已收藏  0 取消
      this.$set(this.list[index], 'isCollect', type) // 收藏成功以后不必重新
    }, // 收藏或取消收藏以后的操作

    showCollect({ code, msg }, txt) { // 显示收藏信息
      let type = 'cancel'
      if (code === 200) type = 'success'
      this.$showToast({ text: code === 200 ? txt: msg, type });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/game/collect-mx.js